// MetalsMaterialsPage.js
import React from 'react';
import { Box, Typography, Container, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// Removed import of PageLayout as it is no longer used

const MetalsMaterialsPage = () => {
  // Define breadcrumbs directly within the component
  const breadcrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Metals & Materials', path: '/metals-materials' },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 2 }}>
      <Container sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
        {/* Breadcrumbs */}
        <Box sx={{ mb: { xs: 2, md: 4 }, px: { xs: 2, md: 0 } }}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              crumb.path ? (
                <MuiLink component={RouterLink} to={crumb.path} key={index} underline="hover" color="text.secondary" variant="body2">
                  {crumb.name}
                </MuiLink>
              ) : (
                <Typography key={index} color="text.primary" variant="body2">{crumb.name}</Typography>
              )
            ))}
          </Breadcrumbs>
        </Box>

        <Typography variant="h3" align="center" fontWeight={700} sx={{ mb: { xs: 4, md: 6 }, color: 'text.primary' }}>
          Metals & Materials
        </Typography>

        <Typography variant="body1" paragraph>
          This section provides an overview of all the different types of metals and other materials that can be traded on our platform. From common ferrous metals to rare specialized alloys, we cover a comprehensive range.
        </Typography>
        <Typography variant="body1" paragraph>
          Explore the sub-categories to dive deeper into specific material types and their market characteristics.
        </Typography>
        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" sx={{ mb: 2, color: 'primary.dark' }}>Material Categories</Typography>
          <MuiLink component={RouterLink} to="/metals-materials/ferrous" sx={{ mr: 2 }}>
            Ferrous Metals
          </MuiLink>
          <MuiLink component={RouterLink} to="/metals-materials/non-ferrous" sx={{ mr: 2 }}>
            Non-Ferrous Metals
          </MuiLink>
          <MuiLink component={RouterLink} to="/metals-materials/specialized-scrap">
            Specialized Scrap
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
};

export default MetalsMaterialsPage;
